import RestService from '@/services/RestService';

export default {
  methods: {
    afterLogin() {
      const token = this.$store.getters['UserStore/getToken'];
      if (!token) {
        return;
      }
      const isParentApp = this.$store.getters['ConfigStore/isParentApp'];
      const isParent = this.$store.getters['UserStore/isParent'];
      const isTeacherApp = this.$store.getters['ConfigStore/isTeacherApp'];
      const isTeacher = this.$store.getters['UserStore/isTeacher'];
      const isStudentApp = this.$store.getters['ConfigStore/isStudentApp'];
      const isStudent = this.$store.getters['UserStore/isStudent'];

      const needRrdirectToParentApp =
        (isTeacherApp || isStudentApp) && isParent;
      const needRrdirectToStudentApp =
        (isTeacherApp || isParentApp) && isStudent;
      const needRrdirectToTeacherApp =
        (isStudentApp || isParentApp) && isTeacher;

      if (needRrdirectToStudentApp) {
        const redirectUrl = this.$store.getters[
          'ConfigStore/getRedirectStudentUrl'
        ];
        window.location.href = redirectUrl;
        return;
      } else if (needRrdirectToTeacherApp) {
        const redirectUrl = this.$store.getters[
          'ConfigStore/getRedirectTeacherUrl'
        ];
        window.location.href = redirectUrl;
        return;
      } else if (needRrdirectToParentApp) {
        const redirectUrl = this.$store.getters[
          'ConfigStore/getRedirectParentUrl'
        ];
        window.location.href = redirectUrl;
        return;
      }

      RestService.setToken(token);
      this.$router.push({
        name: this.routeAfterLogin,
        query: this.$route.query,
      });
    },
  },
};
